import { openBlock as e, createElementBlock as t, createElementVNode as o } from "vue";
const c = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, s = /* @__PURE__ */ o("path", { d: "M4 14.09c0 .355.336.642.75.642s.75-.287.75-.641V2.129c0-.354-.336-.64-.75-.64s-.75.286-.75.64v11.962Zm8.561-11.377a1.006 1.006 0 0 0-1.1.221L7.103 7.287a1.01 1.01 0 0 0 0 1.418l4.358 4.358c.29.297.713.38 1.093.221s.623-.519.63-.927V3.64a1.01 1.01 0 0 0-.623-.927Z" }, null, -1), n = [
  s
];
function r(a, l) {
  return e(), t("svg", c, [...n]);
}
const _ = { render: r };
export {
  _ as default,
  r as render
};
